module.exports = __webpack_public_path__ + "static/media/bannerPic.120d4b78.svg";